import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import store from './store';
import VInput from '@/components/VInput';
// import VueScrollTo from 'vue-scrollto'; //https://www.npmjs.com/package/vue-scrollto
import axios from 'axios';

const app = createApp(App);

// app.use(VueScrollTo);
// app.use(VueResource);
app.use(VueCookies);
app.component('v-input', VInput);

app.config.productionTip = false;

/* eslint-disable-next-line */
axios.defaults.baseURL = CONFIG_API_URL;

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Methods'] =
	'GET,PUT,POST,DELETE,OPTIONS';
axios.defaults.headers.common['Access-Control-Allow-Headers'] =
	'Content-Type, Origin, X-Requested-With, Content-Type, Accept';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = 'Token ' + CONFIG_API_TOKEN; // eslint-disable-line
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.defaults.withCredentials = true;

app.use(router).use(store).mount('#app');
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
